import axios from 'axios';
import { registerErrorInterceptor } from './error.interceptor';
import { registerFirebaseInterceptor } from './firebase.interceptor';

registerErrorInterceptor(axios);
registerFirebaseInterceptor(axios);
